import { indexDB } from 'ynf-core-middleware'
import { requestRefMeta } from './service';

const referIndexDB = {
  indexDB: null,
  tableName: 'refCache',
  init: async () => {
    if (referIndexDB.indexDB) return referIndexDB.indexDB
    referIndexDB.indexDB = await indexDB.init('referCache', 1, [{ tableName: referIndexDB.tableName, options: { keyPath: "refCode", autoIncrement: false } }]);
  },
  setCache: async (key, value, time = 0) => {
    await referIndexDB.init()
    const expiration = time ? (new Date().getTime() + 1000 * 60 * time) : 0
    return referIndexDB.indexDB.insert(referIndexDB.tableName, { refCode: key, time: expiration, value: value })
  },
  getCache: async (key) => {
    await referIndexDB.init()
    const res = await referIndexDB.indexDB.queryByPrimaryKey(referIndexDB.tableName, key);
    if (res?.time && new Date().getTime() > res?.time) {
      return undefined
    }
    return res
  },
  clearCache: async () => {
    await referIndexDB.init()
    return referIndexDB.indexDB.clearTable(referIndexDB.tableName)
  },
  getRefMeta: async (opt, isCache = false) => {
    await referIndexDB.init()
    const key = `refermeta_${opt.refCode}`
    let meta
    const cache = await referIndexDB.getCache(key)
    if (cache && isCache) {
      meta = cache.value
    } else {
      meta = await requestRefMeta(opt)
      referIndexDB.setCache(key, meta, 4320)
    }
    // meta = await requestRefMeta(opt)
    return meta
  }

}

export default referIndexDB